import React from "react";
import FlightCardBoundMobile from "./components/FlightCardBound";
import Frame from "../Frame";
import useFlightCardController, { FlightCardControllerProps } from "./useFlightCard.controller";

const _FlightCardMobile = (
  props: FlightCardControllerProps & {
    /* start - flights_split_bounds_us */
    boundsVariant?: "outbound" | "inbound";
    /* end - flights_split_bounds_us */
  }
) => {
  const {
    ariaLabel,
    bigLogo,
    flight,
    forceHideLastAvailableSeats,
    handleOnClick,
    index,
    isAlternativeFareCard,
    mb,
    mt,
    ref,
    searchType
  } = useFlightCardController(props);

  return (
    <Frame
      mt={mt !== undefined ? mt : 2}
      mb={mb !== undefined ? mb : 4}
      elementRef={ref}
      attributes={{ role: "group", "aria-label": ariaLabel }}
    >
      <FlightCardBoundMobile
        flight={flight}
        onClick={handleOnClick}
        pricePerPerson
        index={index}
        bigLogo={bigLogo}
        searchType={searchType}
        /* start - flights_alternative_fares_for_sold_out_errors_web */
        forceHideLastAvailableSeats={forceHideLastAvailableSeats}
        isAlternativeFareCard={isAlternativeFareCard}
        /* end - flights_alternative_fares_for_sold_out_errors_web */
        /* start - flights_split_bounds_us */
        boundsVariant={props.boundsVariant}
        /* end - flights_split_bounds_us */
      />
    </Frame>
  );
};

const FlightCardMobile = React.memo(_FlightCardMobile);

export default FlightCardMobile;
